var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthDiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#d1315c;}.cls-3{fill:#ff75b0;}.cls-4{fill:#ffcfea;}.cls-5{fill:#febe10;}.cls-6{fill:#a67c52;}.cls-7{fill:#fffbc5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.67,
    y: 0.29,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "health_diary_copy_2",
    "data-name": "health diary copy 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 510.99,
    y: 325.35,
    width: 65.49,
    height: 108.79,
    rx: 32.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 510.99,
    y: 205.02,
    width: 65.49,
    height: 108.79,
    rx: 32.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 510.99,
    y: 84.69,
    width: 65.49,
    height: 108.79,
    rx: 32.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 46.03,
    y: 1.44,
    width: 497.7,
    height: 600,
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.85,1.44H138a0,0,0,0,1,0,0v600a0,0,0,0,1,0,0H75.09A29.05,29.05,0,0,1,46,572.39V31.26A29.81,29.81,0,0,1,75.85,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M206.21,333h43.17l22.22-48.33a12.06,12.06,0,0,1,11-6.9,11.86,11.86,0,0,1,10.71,7.4l21.24,52.47,13.32-23.7a11.94,11.94,0,0,1,10.16-6.05,11.55,11.55,0,0,1,10.07,5.33L362.23,247a11.54,11.54,0,0,1,11.91-9.38,11.83,11.83,0,0,1,11.39,10L399.19,333H460.1a123,123,0,0,0,12.41-31.46c4-16.83,2.92-27.61,2.44-30.66-4.36-46.49-38-80.19-80-80.19a79.84,79.84,0,0,0-62.45,30.54c-14.89-19.46-36.95-30.54-61.12-30.54-42.05,0-75.65,33.69-80,80.19-.46,3.05-1.57,13.83,2.44,30.66A123.76,123.76,0,0,0,206.21,333"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M389.08,356.7a11.84,11.84,0,0,1-11.7-10l-5.2-32.47-7.07,33.26a11.86,11.86,0,0,1-21.75,3.66l-4.74-7.86L323.2,370.73a11.83,11.83,0,0,1-10.34,6,6,6,0,0,1-.74,0,11.85,11.85,0,0,1-10.25-7.37l-20.2-49.88-13.92,30.3A11.88,11.88,0,0,1,257,356.7H223.28a136.25,136.25,0,0,0,10.17,10.23l99.7,88.65,99.74-88.67A137.63,137.63,0,0,0,443,356.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDiary);
export default __webpack_public_path__ + "static/media/health_diary.7f9414ab1dfa18783105ee0a49ea2c6e.svg";
export { ForwardRef as ReactComponent };